import { isFeatureActive } from '../../redux/reducers/config/configReducer';
import featureConstants from '../../constants/featureConstants';
import userConstants from '../../constants/userConstants';
import deliveryConstants from '../../constants/deliveryConstants';

export default function shouldSkipDeliveryPage(state) {
  if (!isFeatureActive(state, featureConstants.ENABLE_FULFILMENT_PREFERENCE)) {
    return false;
  }

  if (state.delivery.deliveries?.length > 1) {
    // multibatch
    return false;
  }

  if (state.delivery.tradeplaceItemsWithUndeliverableQuantity?.length > 0) {
    return false;
  }

  if (state.delivery.undeliverableItemsInBasket?.length > 0) {
    return false;
  }

  if (state.app.fulfilmentPreferenceHappened) {
    return false;
  }

  if (state.user.customerPreferences?.fulfilmentChoice !== userConstants.FULFILMENT_PREFERENCE_DELIVERY) {
    return false;
  }

  if (state.delivery.deliveries[0].type === deliveryConstants.GREEN_VAN_FLEET) {
    return false;
  }

  if (!state.delivery.confirmedDeliveryAddress.defaultShipping) {
    return false;
  }

  return true;
}
